<dx-toolbar class="yo-toolbar">
  <dxi-item location="before">
      <yo-help lang="fr" [file]="pathFile" [dialogMsgSupplier]="help()" [width]="800"></yo-help>
      <yo-button
        iconClass="fa fa-plus"
        [theme]="ButtonThemeEnum.ADD"
        label="CRÉER"
        (onClick)="openDialog(undefined)"
        tooltip="Créer un site">
      </yo-button>
  </dxi-item>
</dx-toolbar>

<dx-data-grid
  [dataSource]="sitesForGrille"
  keyExpr="id"
  [height]="utils.getWindowAvailableHeight(182)"
  width="100%"
  [hoverStateEnabled]="true"
  [rowAlternationEnabled]="true"
  [allowColumnResizing]="true"
  [showRowLines]="true"
  [showBorders]="true"
  [(selectedRowKeys)]="selectedRows"
  #grid>

  <dxi-column dataField="id" caption="Actions" cellTemplate="templateActions" [width]="100"
              [allowFiltering]="false"></dxi-column>
  <dxi-column dataField="libelle" caption="Libellé" cellTemplate="libelleCellTemplate"></dxi-column>
  <div *dxTemplate="let cell of 'libelleCellTemplate'">
    {{cell.row.data?.libelle}}
    <div>
      <yo-gef-audit-button
        [gefAuditList]="gefSvc.retrieveGefAuditListByIdEntity(gefAuditList, cell.row.data.id)">
      </yo-gef-audit-button>
    </div>
  </div>
  <dxi-column dataField="reference" caption="Code"></dxi-column>
  <dxi-column dataField="adresse1" caption="Adresse"></dxi-column>
  <dxi-column dataField="ville" caption="Ville"></dxi-column>
  <dxi-column dataField="telephone" caption="Téléphone"></dxi-column>
  <dxi-column dataField="actif" caption="Actif"></dxi-column>

  <div *dxTemplate="let cell of 'templateActions'" class="custom-button-container">
    <yo-button size="small"
                    [theme]="ButtonThemeEnum.DEFAULT_INNER" (onClick)="openDialog(cell.row.data)"
                    iconClass="fa fa-edit"
                    [tooltip]="'Modifier le site ' + cell.row.data.libelle">
    </yo-button>
    <yo-button size="small"
                    [theme]="ButtonThemeEnum.DELETE_INNER" (onClick)="confirmDelete(cell.row.data)"
                    iconClass="fa fa-trash"
                    [tooltip]="'Supprimer le site '+ cell.row.data.libelle">
    </yo-button>
  </div>

  <dxo-filter-row [visible]="true"></dxo-filter-row>
  <dxo-sorting mode="multiple"></dxo-sorting>

  <dxo-pager
    [showPageSizeSelector]="true"
    [showNavigationButtons]="false"
    [allowedPageSizes]="[20, 50, 100, 200]"
    [visible]="true"
    [showInfo]="true"
    infoText="{2} site(s)">
  </dxo-pager>

</dx-data-grid>

<yo-ficheidentite-site></yo-ficheidentite-site>
<yo-dialog-gef-audit></yo-dialog-gef-audit>

<dx-popup
  [showTitle]="true"
  title="Lignes n'ayant pas été supprimées"
  [visible]="displayDeletePopupErrors"
  [height]="'auto'"
  [deferRendering]="false"
  [resizeEnabled]="true"
  [showCloseButton]="true"
  (onHidden)="closeErrors()"
>
  <label>Les éléments non présents dans cette liste ont bien été supprimés.</label>
  <dx-data-grid
    [dataSource]="errors"
    keyExpr="infosLine"
    [hoverStateEnabled]="true"
    [rowAlternationEnabled]="true"
    [allowColumnResizing]="true"
    [showRowLines]="true"
    [showBorders]="true"
    columnResizingMode="widget"
    (onContentReady)="onDeleteErrorsGridReady()"
  >
    <dxi-column dataField="infosLine" caption="Ligne non supprimée" [filterOperations]="['contains']"
                [allowFiltering]="true"></dxi-column>
    <dxo-filter-row [visible]="true"></dxo-filter-row>
    <dxo-pager
      [showPageSizeSelector]="true"
      [showNavigationButtons]="false"
      [allowedPageSizes]="[20, 50, 100, 200]"
      [visible]="true"
      [showInfo]="true"
      infoText="{2} erreur(s)">
    </dxo-pager>
  </dx-data-grid>
</dx-popup>
